var indicative = require("indicative");

var passwordUtils = (function() {

    var _validate_password_reset_request = function(email) {
        var Indicative = new indicative();

        var rules = {
            email: 'required|email'
        };

        var messages = {
            "email.required": "Email address is required",
            "email.email": "Email address is not valid"
        };

        var data = {
            email: email
        };

        return Indicative
            .validateAll(rules, data, messages)
            .then(function(validation_passed) {
                return true;
            })
            .catch(function(error) {
                var errorMessage = '';
                for (var i = 0, errorLength = error.length; i < errorLength; i++) {
                    errorMessage += error[i].message + '\n';
                };
                return errorMessage;
            });
    };

    var _validate_password_reset = function(password, rePassword) {
        var Indicative = new indicative();

        var rules = {
            password: 'required|min:8',
            rePassword: 'required|same:password'
        };

        var messages = {
            "password.required": "Password is required",
            "password.min": "Password should be at least 8 characters",
            "rePassword.required": "Re-enter Password is required",
            "rePassword.same": "Re-enter Password should be equal with Password"
        };

        var data = {
            password: password,
            rePassword: rePassword
        };

        return Indicative
            .validateAll(rules, data, messages)
            .then(function(validation_passed) {
                return true;
            })
            .catch(function(error) {
                var errorMessage = '';
                for (var i = 0, errorLength = error.length; i < errorLength; i++) {
                    errorMessage += error[i].message + '\n';
                };
                return errorMessage;
            });
    };

    return {
        validate_password_reset_request: _validate_password_reset_request,
        validate_password_reset: _validate_password_reset
    };

})();

module.exports = passwordUtils;



// WEBPACK FOOTER //
// ./src/common/modules/password/passwordUtils.js